import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Bussinessyeppy = () => {
  return (
    <div className="bussiness_yeppy p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className=" m-auto text-center"
          >
            <h2>Business Challenges</h2>
          </Col>
        </Row>

        <Row className="padd_top">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="my-auto">
            <div className="buss_box">
              <div className="buss_img">
                <StaticImage
                  src="../../../images/case-studies/yeppy/1.png"
                  alt="TekRevol"
                  className="img-fluid logo_img"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={49}
                />
              </div>
              <div className="buss_content">
                <p>
                  Building partnerships with various businesses to onboard their
                  services on Yeppy and expand the app's offerings in the Middle
                  East, eventually worldwide.
                </p>
              </div>
            </div>
            <div className="buss_img_1">
              <StaticImage
                src="../../../images/case-studies/yeppy/challenge_card.png"
                alt="TekRevol"
                className="img-fluid logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={470}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="resp_order">
            <div className="buss_big_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/challenge_img.png"
                alt="TekRevol"
                className="img-fluid logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={630}
              />
            </div>
            <div className="buss_box_2">
              <div className="buss_img_2">
                <StaticImage
                  src="../../../images/case-studies/yeppy/3.png"
                  alt="TekRevol"
                  className="img-fluid logo_img"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={49}
                />
              </div>
              <div className="buss_content_2">
                <p>
                  Thus, maintaining a user-friendly and intuitive interface that
                  can accommodate a wide range of services.
                </p>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={3}
            xxl={3}
            className="my-auto resp_order1"
          >
            <div className="buss_img_4">
              <StaticImage
                src="../../../images/case-studies/yeppy/challenge_card_2.png"
                alt="TekRevol"
                className="img-fluid logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={430}
              />
            </div>
            <div className="buss_box">
              <div className="buss_img">
                <StaticImage
                  src="../../../images/case-studies/yeppy/2.png"
                  alt="TekRevol"
                  className="img-fluid logo_img"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={49}
                />
              </div>
              <div className="buss_content">
                <p>
                  Ensuring secure and seamless payment processing within the
                  app. Effective marketing and promotion to attract and retain a
                  substantial user base.
                </p>
              </div>
            </div>
            <div className="buss_img_5">
              <StaticImage
                src="../../../images/case-studies/yeppy/challenge_last_img.png"
                alt="TekRevol"
                className="img-fluid logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={470}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Bussinessyeppy;
